import WebsiteChartBase from "./website-fund-chart-base";
import { MergeDataCommon } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";

class FundPerformanceChart extends WebsiteChartBase {
    constructor(containerId, fundCode) {
        super(containerId, fundCode);
        this.fundCode = fundCode;
        this.containerId = containerId;
        this.chart = null;
    }

    bindEvents() {
        super.bindEvents();
        $(window).on("resize", () => {
            const currentWindowWidth = window.innerWidth;
            if (currentWindowWidth !== this.previousWindowWidth) {
                this.handleResize();
                this.previousWindowWidth = currentWindowWidth;
            }
        });
    }

    getApiUrl() {
        return FUND_API_SOURCES.FUND_PERFORMANCE_FUND_SOURCE;
    }

    mergeData(performanceResData) {
        return this.mergePerformanceData(performanceResData);
    }

    errorHandler() {
        showApiMessageing(null);
        this.setEmptyMessage();
    }

    setEmptyMessage() {
        $("#container-performance-c").find(".fil-highcharts-range-selectors").remove();
        if ($("#container-performance")) {
            $("#container-performance")
                .empty()
                .append("<div>暂无数据显示</div>")
                .css({ display: "flex", "align-items": "center", "justify-content": "center" });
            $(".camc-fund-performance__chart--description#performance-description").remove();
        }
    }

    createChart({ performanceDataArrayApi, bmInfoDataMap, priceDate }) {
        let hushen300ArrayDataGroup = Object.values(bmInfoDataMap).map((value) => value.data);
        let hushen300ArrayNameGroup = Object.values(bmInfoDataMap).map((value) => value.indexName + " ");

        if (priceDate) {
            $("#performance-updatetime").text("更新日期：" + priceDate);
        }
        $("#performance-datasource").show();

        this.originalPerformanceDataArrayApi = JSON.parse(JSON.stringify(performanceDataArrayApi));
        this.originalHushen300ArrayDataGroup = hushen300ArrayDataGroup.map((dataArray) =>
            JSON.parse(JSON.stringify(dataArray)),
        );

        let startFundDate = null;
        let endFundDate = null;
        if (performanceDataArrayApi && performanceDataArrayApi.length > 0) {
            startFundDate = new Date(performanceDataArrayApi[0]["x"]);
            endFundDate = new Date(performanceDataArrayApi[performanceDataArrayApi.length - 1]["x"]);
        }

        this.startFundDate = startFundDate;
        this.endFundDate = endFundDate;
        this.chartMaxDate = endFundDate;
        this.ytdDiff = endFundDate.getFullYear() > startFundDate.getFullYear() ? 24 * 3600 * 1000 : 0;
        let filData = this.getPerformanceChangeData(performanceDataArrayApi, startFundDate, endFundDate);
        let benchMarkDataGroup = hushen300ArrayDataGroup.map((dataArray) => {
            return this.getPerformanceChangeData(dataArray, startFundDate, endFundDate);
        });

        var options = {
            rangeSelector: {
                selected: 7,
                buttonSpacing: 3,
                buttonTheme: {
                    // styles for the buttons
                    fill: "none",
                    // width: null,
                    // height: -10,
                    style: {
                        color: "#039",
                    },

                    states: {
                        select: {
                            fill: "#016FAD",
                            style: {
                                color: "white",
                                cursor: "default",
                            },
                        },
                        disabled: {
                            fill: "none",
                            style: {
                                cursor: "default",
                            },
                        },
                    },
                },

                inputPosition: {
                    x: -20,
                },
                inputDateFormat: "%Y-%m-%d",
                labelStyle: {
                    color: "black",
                },
                buttons: [
                    {
                        type: "ytd",
                        text: "年初至今",
                        offsetMin: this.ytdDiff,
                    },
                    {
                        type: "month",
                        count: 3,
                        text: "3个月",
                        offsetMin: 24 * 3600 * 1000,
                    },
                    {
                        type: "month",
                        count: 6,
                        text: "6个月",
                        offsetMin: 24 * 3600 * 1000,
                    },
                    {
                        type: "year",
                        count: 1,
                        text: "1年",
                        offsetMin: 24 * 3600 * 1000,
                        tset: "sss",
                    },
                    {
                        type: "year",
                        count: 3,
                        text: "3年",
                        offsetMin: 24 * 3600 * 1000,
                    },
                    {
                        type: "year",
                        count: 5,
                        text: "5年",
                        offsetMin: 24 * 3600 * 1000,
                    },
                    {
                        type: "year",
                        count: 10,
                        text: "10年",
                        offsetMin: 24 * 3600 * 1000,
                    },
                    {
                        type: "all",
                        text: "成立至今",
                    },
                ],
            },

            xAxis: {
                showEmpty: false,
                events: {
                    afterSetExtremes: (e) => {
                        let min = new Date(e.min);
                        let max = new Date(e.max);
                        min = new Date(min.toISOString().slice(0, 10));
                        max = new Date(max.toISOString().slice(0, 10));

                        chart.xAxis[0].setExtremes(min.getTime(), max.getTime());
                        this.datepickerUpdate(min, max);
                        this.updateRangeButtonStatus();
                    },
                    setExtremes: (e) => {
                        let min = new Date(e.min);
                        let max = new Date(e.max);
                        min = new Date(min.toISOString().slice(0, 10));
                        max = new Date(max.toISOString().slice(0, 10));

                        let originalPerformanceDataArrayApi = JSON.parse(
                            JSON.stringify(this.originalPerformanceDataArrayApi),
                        );

                        let originalHushen300ArrayDataGroup = JSON.parse(
                            JSON.stringify(this.originalHushen300ArrayDataGroup),
                        );

                        let performanceData = this.getPerformanceChangeData(originalPerformanceDataArrayApi, min, max);

                        let benchMarkDataGroup = originalHushen300ArrayDataGroup.map((dataArray) => {
                            return this.getPerformanceChangeData(dataArray, min, max);
                        });

                        chart.series[0].update(
                            {
                                data: performanceData,
                            },
                            false,
                        );
                        benchMarkDataGroup.forEach((data, index) => {
                            if (chart.series[index + 1]) {
                                chart.series[index + 1].update(
                                    {
                                        data: data,
                                    },
                                    false,
                                );
                            } else {
                                chart.addSeries(
                                    {
                                        name: hushen300ArrayNameGroup[index],
                                        data: data,
                                    },
                                    false,
                                );
                            }
                        });
                        chart.redraw();

                        this.updateRangeButtonStatus();
                        this.datepickerUpdate(min, max);
                    },
                },
                tickInterval: 24 * 3600 * 1000,
                type: "datetime",
                dateTimeLabelFormats: {
                    week: "%m-%d",
                    day: "%m-%d",
                    month: "%Y-%m",
                    year: "%Y",
                },
            },

            chart: {
                renderTo: this.containerId,
                type: "spline",
                marginRight: 10,
                marginTop: 0,
                marginLeft: 10,
                spacingBottom: 5,
                reflow: true,
                style: {
                    fontFamily: "neuzeit_grotesk, Noto Sans SC, Noto Sans CJK SC, sans-serif !important;",
                },
                events: {},
            },

            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#303030",
                },
            },
            series: [
                {
                    turboThreshold: 0,
                    data: [],
                    dataGrouping: this.dataGrouping,
                },
                ...benchMarkDataGroup.map((data, index) => ({
                    name: hushen300ArrayNameGroup[index],
                    data: data,
                    dataGrouping: this.dataGrouping,
                    turboThreshold: 0,
                })),
            ],

            legend: {
                useHTML: true,
                enabled: true,
                labelFormatter: function () {
                    return '<span title="' + this.name + '">' + this.name + "</span>";
                },
                align: "left",
                itemStyle: {
                    fontSize: "14px",
                    fontWeight: "normal",
                    textOverflow: "unset",
                    paddingBottom: "8px",
                },
            },
            navigator: {
                xAxis: {
                    ordinal: true,
                    tickInterval: 24 * 3600 * 1000,
                    type: "datetime",
                    dateTimeLabelFormats: {
                        day: "%m-%d",
                        week: "%m-%d",
                        month: "%Y-%m",
                        year: "%Y",
                    },
                },
                series: [
                    {
                        turboThreshold: 0,
                        data: [],
                    },
                    ...benchMarkDataGroup.map((data, index) => ({
                        name: hushen300ArrayNameGroup[index],
                        data: data,
                        turboThreshold: 0,
                    })),
                ],
            },

            colors: ["#0D72AF", "#EA6A18", "#FFC000", "#82C823"],

            yAxis: {
                labels: {
                    formatter: function () {
                        return (this.value > 0 ? "" : "") + this.value + "%";
                    },
                },
            },

            plotOptions: {
                series: {
                    type: "spline",
                    showInNavigator: false,
                    states: {
                        inactive: {
                            enabled: false,
                        },
                    },
                    events: {
                        legendItemClick: (e) => {
                            e.preventDefault();
                            e.target.setVisible(!e.target.visible);

                            chart.series.some((series) => {
                                if (!series.options.isInternal && series.visible === true) {
                                    this.$rangeSelectors.find("input").prop("disabled", false);
                                    this.initRangeButton(options);
                                    this.updateRangeButtonStatus();
                                    return true;
                                }

                                this.$rangeSelectors.find("input").prop({ disabled: true, checked: false });
                            });
                        },
                    },
                },
            },

            tooltip: {
                useHTML: true,
                formatter: function () {
                    return this.points.reduce(
                        (s, point) =>
                            `${s}<div class="fund-name">
                                    <div class="fund-tooltip">
                                        <div class="fund-tooltip--name" style="color:${point.series.color}">
                                            ${point.series.name}
                                        </div>
                                        <div>:&nbsp;</div>
                                    </div>
                                    <div>${MergeDataCommon.formatNumber(point.y, 2)}%</div>
                                </div>`,
                        `<b>${Highcharts.dateFormat("%Y - %m - %d", new Date(this.x))}</b>`,
                    );
                },
            },
            labelStyle: {
                color: "black",
            },
            credits: {
                enabled: false,
            },
        };

        options.series[0].data = filData;
        options.navigator.series[0].data = filData;
        options.series[0].name = `${window.fundName}` + " ";

        Highcharts.setOptions({
            lang: {
                rangeSelectorFrom: "由",
                rangeSelectorTo: "到",
                rangeSelectorZoom: "查看: ",
                noData: "No data to display",
            },
        });

        var chart = Highcharts.stockChart(this.containerId, options, (chart) => {
            setTimeout(function () {
                if (chart.options && chart.options.chart) {
                    $("input.highcharts-range-selector", $("#" + chart.options.chart.renderTo)).fdatepicker({
                        format: "yyyy-mm-dd",
                        disableDblClickSelection: true,
                        language: "zh-CN",
                        startDate: startFundDate,
                        endDate: endFundDate,
                    });
                } else {
                    $("input.highcharts-range-selector", $("#" + chart.renderTo)).fdatepicker({
                        format: "yyyy-mm-dd",
                        disableDblClickSelection: true,
                        language: "zh-CN",
                        startDate: startFundDate,
                        endDate: endFundDate,
                    });
                }
            }, 0);

            this.datepickerInit("performance", startFundDate, endFundDate);
        });

        this.initRangeButton(options);
        this.chart = chart;
        this.updateRangeButtonStatus();
        this.updateRangeButtonPosition(7);
        $("#performance-updatetime").show();

        return chart;
    }

    handleResize() {
        if (this.chart && this.chart.xAxis && this.chart.xAxis[0]) {
            const extremes = this.chart.xAxis[0].getExtremes();
            let minDate = new Date(extremes.min);
            let maxDate = new Date(extremes.max);

            const legendVisibility = this.chart.legend.allItems.map((item) => ({
                name: item.name,
                visible: item.visible,
            }));

            this.chart.destroy();
            this.chart = null;

            this.createChart(this.data);
            legendVisibility.forEach((legend) => {
                const series = this.chart.series.find((s) => s.name === legend.name);
                if (series) {
                    series.setVisible(legend.visible, false);
                }
            });
            this.chart.xAxis[0].setExtremes(minDate.getTime(), maxDate.getTime());
        }
    }
}

export default FundPerformanceChart;
